module.exports = __webpack_public_path__ + "static/media/image.06691162.svg";